export enum UserPlanType {
  Premium = "Premium",
  Free = "Free",
}
